module.exports = __webpack_public_path__ + "static/media/fb1.2bffbd64.png";